import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'export']

  async selectDay (event) {
    const select = event.currentTarget
    const form = select.form
    if (form === null) return

    const activeMetric = this.contentTarget.querySelector('.eventInsights-trendTabs button.is-active')?.dataset.metricId
    const url = new URL(form.action, window.location.origin)
    url.searchParams.set('day', select.value)
    if (activeMetric !== undefined) url.searchParams.set('metric', activeMetric)

    select.disabled = true
    this.contentTarget.setAttribute('aria-busy', 'true')

    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } })
      if (!response.ok) throw new Error(`Insights request failed with status ${response.status}`)

      const document = new DOMParser().parseFromString(await response.text(), 'text/html')
      const replacement = document.querySelector('.eventInsights-content')
      if (replacement === null) throw new Error('Insights response did not contain dashboard content')

      this.contentTarget.innerHTML = replacement.innerHTML

      const replacementExport = document.querySelector('.eventInsights-export')
      if (this.hasExportTarget && replacementExport !== null) this.exportTarget.href = replacementExport.href
    } catch (error) {
      console.error(error)
    } finally {
      select.disabled = false
      this.contentTarget.removeAttribute('aria-busy')
    }
  }
}
